import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as authenticationActions } from '../actions/authentication'

class CallbackV2 extends Component {
  componentDidMount() {
    this.props.actions.authentication.receiveAuthentication()
  }

  render() {
    return null
  }
}

const mapState = state => ({
  auth: state.auth
})

const mapDispatchToProps = dispatch => ({
  actions: {
    authentication: bindActionCreators(authenticationActions, dispatch),
  }
})

export default connect(mapState, mapDispatchToProps)(CallbackV2)
